// @flow

import React from 'react'
import urlParse from 'url-parse'
import styled from 'styled-components'
import { mediaMax } from 'frontend_core/dist/styles/media'

const Image = styled.img`
  display: inline-block;
`

const FlexImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
`

const CoverImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: 100%;
  transform: translate(-50%, -50%);
  ${mediaMax.phone`
    width: 140%;
  `};
`

const ResponsiveImage = styled.img`
  position: absolute;
  height: 100%;
  left: 50%;
  top: 50%;
  min-width: 100%;
  transform: translate(-50%, -50%);
  ${mediaMax.phone`
    position: static;
    width: 100%;
    height: auto;
    transform: translate(0);
  `};
`

const Source = styled.source`
  display: inline-block;
`

const FlexSource = styled.source`
  display: block;
  width: 100%;
  height: auto;
`

const CoverSource = styled.source`
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: 100%;
  transform: translate(-50%, -50%);
`

const ResponsiveSource = styled.source`
  position: absolute;
  height: 100%;
  left: 50%;
  top: 50%;
  min-width: 100%;
  transform: translate(-50%, -50%);
  ${mediaMax.phone`
    position: static;
    width: 100%;
    height: auto;
    transform: translate(0);
  `};
`

type SourceTypes = 'cover' | 'flex' | 'responsive'

type PropTypes = {
  src: string,
  alt?: string,
  width?: number,
  height?: number,
  className?: string,
  type?: SourceTypes,
  aspectWidth?: number,
  aspectWidthSp?: number,
}

function format(src: string = '') {
  const url = urlParse(src)
  const isTargetExtention = !!(src || '').match(/\.(jpg|jpeg|png|gif)/i)
  if (url.host === 'cdnspacemarket.com' && isTargetExtention) {
    const query = 'of=webp'
    const newQuery = url.query ? `${url.query}&${query}` : `?${query}`
    url.set('query', newQuery)
  }
  return url.href
}

function getSource(props: PropTypes) {
  const { src, type, aspectWidth, aspectWidthSp } = props

  switch (type) {
    case 'cover':
      return <CoverSource type="image/webp" srcSet={format(src)} />
    case 'flex':
      return <FlexSource type="image/webp" srcSet={format(src)} />
    case 'responsive':
      return (
        <ResponsiveSource
          type="image/webp"
          srcSet={format(src)}
          aspectWidth={aspectWidth}
          aspectWidthSp={aspectWidthSp}
        />
      )
    default:
      return <Source type="image/webp" srcSet={format(src)} />
  }
}

function getImage(props: PropTypes) {
  const {
    src,
    width,
    height,
    className,
    alt,
    type,
    aspectWidth,
    aspectWidthSp,
  } = props
  const params = {
    src,
    alt,
    width,
    height,
    className,
    aspectWidth,
    aspectWidthSp,
  }

  switch (type) {
    case 'cover':
      return <CoverImage {...params} />
    case 'flex':
      return <FlexImage {...params} />
    case 'responsive':
      return <ResponsiveImage {...params} />
    default:
      return <Image {...params} />
  }
}

export default (props: PropTypes) => (
  <picture>
    {getSource(props)}
    {getImage(props)}
  </picture>
)



// WEBPACK FOOTER //
// ./src/components/atoms/OptimizedImage.jsx